import * as React from 'react';
import { Icon, IconUtils } from '../icon';
import { Spinner } from '../spinner';
/** Render a status icon which can either be pending or errored */
export const Status = React.forwardRef(({ pending, error, errorIcon, spinnerIcon, cypressTag }, ref) => {
    if (!error && !pending) {
        return null;
    }
    return (React.createElement("div", { ref: ref, className: "arm-status", "data-active": !!pending || !!error, "data-error": !!error && !pending, "data-pending": pending, "data-cy": cypressTag },
        error && !pending && React.createElement(Icon, { className: "arm-status-error", iconSet: errorIcon.iconSet, icon: errorIcon.icon }),
        pending && React.createElement(Spinner, { className: "arm-status-spinner", fillContainer: false, icon: spinnerIcon })));
});
Status.defaultProps = {
    errorIcon: IconUtils.getIconDefinition('Icomoon', 'warning'),
};
